/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-12-11 18:06:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-07-08 16:38:43
 * @FilePath: \vue-new-hepha\src\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { useStore } from '@/store/index.js';

import {createRouter,createWebHashHistory} from 'vue-router';
import Layout from '@/layouts/Index.vue';
import Home from '@/views/Home.vue';
import Login from '@/views/Login/Login.vue';
import ForgotPassword from '@/views/Login/ForgotPassword.vue';
import CyclingData from '@/views/DataQuery/CyclingData.vue';
import RideDataStatistic from '@/views/DataQuery/RideDataStatistic.vue';
import BikeInfo from '@/views/DataQuery/BikeInfo.vue';
import TenantList from '@/views/Tenant/TenantList.vue';
import UserList from '@/views/User/UserList.vue';
import FirmwareList from '@/views/Firmware/FirmwareList.vue';
import FirmwareReleaseList from '@/views/FirmwareList/FirmwareList.vue';
import FirmwareRelease from '@/views/FirmwareRelease/FirmwareRelease.vue';
import BikeModelList from '@/views/BikeModel/BikeModelList.vue';
import PartDistribution from '@/views/DataQuery/PartDistribution.vue';
import PartsVersionStatistic from '@/views/DataQuery/PartsVersionStatistic.vue';
import AccessMTG from '@/views/AdvancedFunction/AccessMTG.vue';
import AccountMTG from '@/views/AdvancedFunction/AccountMTG.vue';
import APPVersionList from '@/views/AdvancedFunction/APPVersionList.vue';
import UpgradeRules from '@/views/AdvancedFunction/UpgradeRules.vue';
import ToolPublishManagement from '@/views/AdvancedFunction/ToolPublishManagement.vue';
import PartProjectTenant from '@/views/AdvancedFunction/PartProjectTenant.vue';
import FaultDataBoard from '@/views/Fault/FaultDataBoard.vue';
import FaultCodeMaintenance from '@/views/Fault/FaultCodeMaintenance.vue';
import Role from '@/views/SystemMTG/Role.vue';
import Menu from '@/views/SystemMTG/Menu.vue';
import ErrorPage from '@/views/404.vue';
import ErgoAdjust from '@/views/AdvancedFunction/ErgoAdjust.vue';

const routes = [
    {
        path:'/',
        name:'Index',
        component:Layout,
        redirect:'/Home',
        children:[
            {
                path:'/Home',
                name:'Home',
                component:Home,
                meta:{ 
                    title:"首页",
                    icon:"HomeOutlined",
                    lang:"menu.Home",
                    menuDesc:"menu.subHome",
                    menuIconImg:"menu_icon1",
                    requiresAuth:true,
                }
            },
            {
                path:'/Firmware',
                name:'Firmware',
                component:FirmwareList,
                meta:{
                    title:"固件管理",
                    icon:"CloudUploadOutlined",
                    lang:"menu.Firmware",
                    menuDesc:"menu.subFirmware",
                    menuIconImg:"",
                    requiresAuth:true
                }
            },
            {
                path:'/FirmwareSetting',
                name:'FirmwareSetting',
                redirect:'/FirmwareList',
                meta:{ 
                    title:"固件设置",
                    icon:'CloudUploadOutlined',
                    lang:"menu.FirmwareSetting" 
                },
                children:[
                    {
                        path:'/FirmwareList',
                        name:'FirmwareList',
                        component: FirmwareReleaseList,
                        meta:{
                            title:"固件列表",
                            icon:"CloudUploadOutlined",
                            lang:"menu.FirmwareList",
                            menuDesc:"menu.subFirmwareList",
                            menuIconImg:"",
                            requiresAuth:true
                        }
                    },
                    {
                        path:'/FirmwareRelease',
                        name:'FirmwareRelease',
                        component:FirmwareRelease,
                        meta:{
                            title:"固件发布",
                            icon:"CloudUploadOutlined",
                            lang:"menu.FirmwareRelease",
                            menuDesc:"menu.subFirmwareRelease",
                            menuIconImg:"",
                            requiresAuth:true
                        }
                    }
                    
                ],
            },
            
            {
                path:'/BikeModel',
                name:'BikeModel',
                component:BikeModelList,
                meta:{
                    title:"车型管理",
                    icon:"UnorderedListOutlined", 
                    lang:"menu.BikeModel",
                    menuDesc:"menu.subBikeModel",
                    menuIconImg:"",
                    requiresAuth:true
                }
            },
            {
                path:'/Tenant',
                name:'Tenant',
                component:TenantList,
                meta:{
                    title:"租户管理",
                    icon:"TeamOutlined", 
                    lang:"menu.Tenant",
                    menuDesc:"menu.subTenant",
                    menuIconImg:"",
                    requiresAuth:true
                }
            },
            {
                path:'/User',
                name:'User',
                component:UserList,
                meta:{
                    title:"用户管理",
                    icon:"UserOutlined",
                    lang:"menu.User",
                    menuDesc:"menu.subUser",
                    menuIconImg:"",
                    requiresAuth:true
                }
            },
            {
                path:'/DataQuery',
                name:'DataQuery',
                redirect:'/DataQuery/CyclingData',
                meta:{ 
                    title:"数据查询",
                    icon:'SearchOutlined',
                    lang:"menu.DataQuery" 
                },
                children:[
                    {
                        path:'/DataQuery/CyclingData',
                        name:'CyclingData',
                        component:CyclingData,
                        meta:{ 
                            title:"骑行数据",
                            requiresAuth:true,
                            lang:"menu.CyclingData",
                            menuDesc:"menu.subCyclingData", 
                            menuIconImg:"menu_icon2",
                        },
                    },
                    {
                        path:'/DataQuery/BikeInfo',
                        name:'BikeInfo',
                        component:BikeInfo,
                        meta:{ 
                            title:"车辆信息",
                            requiresAuth:true,
                            lang:"menu.BikeInfo",
                            menuDesc:"menu.subBikeInfo", 
                            menuIconImg:"menu_icon3",
                        }
                    },
                    {
                        path:'/DataQuery/PartDistribution',
                        name:'PartDistribution',
                        component:PartDistribution,
                        meta:{
                            title:"部件分布",
                            requiresAuth:true,
                            lang:"menu.PartDistribution",
                            menuDesc:"",
                            menuIconImg:"menu_icon3",
                        }
                    },
                    {
                        path:'/DataQuery/PartsVersionStatistic',
                        name:'PartsVersionStatistic',
                        component:PartsVersionStatistic,
                        meta:{
                            title:"部件版本统计",
                            requiresAuth:true,
                            lang:"menu.PartsVersionStatistic",
                            menuDesc:"",
                            menuIconImg:"menu_icon3",
                        }
                    },
                    {
                        path:'/DataQuery/RideDataStatistic',
                        name:'RideDataStatistic',
                        component:RideDataStatistic,
                        meta:{
                            title:"骑行数据统计",
                            requiresAuth:true,
                            lang:"menu.RideDataStatistic",
                            menuDesc:"menu.subRideDataStatistic",
                            menuIconImg:"menu_icon2",
                        },
                    },
                ],
            },
            {
                path:'/AdvancedFunction',
                name:'AdvancedFunction',
                meta:{ 
                    title:"高级功能",
                    icon:"AppstoreOutlined",
                    lang:"menu.AdvancedFunction"
                },
                children:[
                    {
                        path:'/AdvancedFunction/AccessMTG',
                        name:'AccessMTG',
                        component:AccessMTG,
                        meta:{ 
                            title:"权限管理",
                            requiresAuth:true,
                            lang:"menu.AccessMTG",
                            menuDesc:"menu.subAccessMTG", 
                            menuIconImg:"menu_icon4",
                        },
                    },
                    {
                        path:'/AdvancedFunction/AccountMTG',
                        name:'AccountMTG',
                        component:AccountMTG,
                        meta:{ 
                            title:"账号管理",
                            requiresAuth:true,
                            lang:"menu.AccountMTG",
                            menuDesc:"menu.subAccountMTG", 
                            menuIconImg:"menu_icon5",
                        },
                    },
                    {
                        path:'/AdvancedFunction/APPVersionList',
                        name:'APPVersionList',
                        component:APPVersionList,
                        meta:{
                            title:"APP版本管理",
                            requiresAuth:true,
                            lang:"menu.appVersion",
                            menuDesc:"menu.subAppVersion",
                            menuIconImg:"menu_icon6",
                        },
                    },
                    {
                        path:'/AdvancedFunction/UpgradeRules',
                        name:'UpgradeRules',
                        component:UpgradeRules,
                        meta:{
                            title:"升级规则",
                            requiresAuth:true,
                            lang:"menu.upgradeRules",
                            menuDesc:"",
                            menuIconImg:"menu_icon6",
                        }
                    },
                    {
                        path:'/AdvancedFunction/ErgoAdjust',
                        name:'ErgoAdjust',
                        component:ErgoAdjust,
                        meta:{
                            title:"人体工学调节",
                            requiresAuth:true,
                            lang:"menu.ErgoAdjust",
                            menuDesc:"menu.subErgoAdjust",
                            menuIconImg:"menu_icon6",
                        }
                    },
                    {
                        path:'/AdvancedFunction/ToolPublishManagement',
                        name:'ToolPublishManagement',
                        component:ToolPublishManagement,
                        meta:{
                            title:"工具发布管理",
                            requiresAuth:true,
                            lang:"menu.toolPublishManagement",
                            menuDesc:"menu.subToolPublishManagement",
                            menuIconImg:"menu_icon6",
                        },
                    },
                    {
                        path:'/AdvancedFunction/PartProjectTenant',
                        name:'PartProjectTenant',
                        component:PartProjectTenant,
                        meta:{
                            title:"部件/项目编号/租户对应关系",
                            requiresAuth:true,
                            lang:"menu.PartProjectTenant",
                            menuDesc:"",
                            menuIconImg:"menu_icon6",
                        }
                    },
                ],
            }, 
            {
                path:'/Fault',
                name:'Fault',
                meta:{ 
                    title:"故障管理",
                    icon:"AlertOutlined",
                    lang:"menu.Fault"
                },
                children:[
                    {
                        path:'/Fault/FaultDataBoard',
                        name:'FaultDataBoard',
                        component:FaultDataBoard,
                        meta:{ 
                            title:"故障数据看板",
                            requiresAuth:true,
                            lang:"menu.FaultDataBoard",
                            menuDesc:"", 
                            menuIconImg:"menu_icon4",
                        },
                    },
                    {
                        path:'/Fault/FaultCodeMaintenance',
                        name:'FaultCodeMaintenance',
                        component:FaultCodeMaintenance,
                        meta:{ 
                            title:"故障码维护",
                            requiresAuth:true,
                            lang:"menu.FaultCodeMaintenance",
                            menuDesc:"", 
                            menuIconImg:"menu_icon4",
                        },
                    },
                ],
            },
            {
                path:'/SystemMTG',
                name:'SystemMTG',
                meta:{ 
                    title:"系统设置",
                    icon:"SettingOutlined",
                    lang:"menu.SystemMTG"
                },
                children:[
                    {
                        path:'/SystemMTG/Role',
                        name:'Role',
                        component:Role,
                        meta:{ 
                            title:"角色管理",
                            requiresAuth:true,
                            lang:"menu.Role",
                            menuDesc:"menu.subRoleMTG", 
                            menuIconImg:"menu_icon4",
                        },
                    },
                    {
                        path:'/SystemMTG/Menu',
                        name:'Menu',
                        component:Menu,
                        meta:{ 
                            title:"菜单管理",
                            requiresAuth:true,
                            lang:"menu.Menu",
                            menuDesc:"menu.subMenuMTG", 
                            menuIconImg:"menu_icon4",
                        },
                    },
                ],
            }, 
        ],
    },
    {
        path:'/Login',
        name:'Login',
        component:Login,
    },
    {
        path:'/ForgotPassword',
        name:'ForgotPassword',
        component:ForgotPassword,
    },
    {
        path:'/404',
        name:'404',
        component:ErrorPage,
    },
    {
        path: '/:catchAll(.*)',  // vue3 使用 /:catchAll(.*) 或 /:pathMatch(.*)
        redirect: '/404',
    },
    
]


const router = createRouter({
    history:createWebHashHistory(),
    routes:routes,
})


export default router
